import jmin from './jMin';

export default class Fields {
	handlers = {}
	data = {}
	map = {}

	constructor() {

	// Add Text handler
		this.textHandler();

		// Add Checkbox handler
		this.checkboxHandler();

		// Add Checkbox Group handler
		this.checkboxGroupHandler();

		// Add Select handler
		this.selectHandler();

		// Add Radio handler
		this.radioHandler();
	}

	addHandler(type, handler) {
		this.handlers[type] = handler;
		this.handlers[type].init();
	}

	get(group) {
		let type = group.dataset.type;
		return {
			val: this.handlers[type].get(group),
			map: group.dataset.map
		};
	}

	set(group, value) {
		let type = group.dataset.type;
		return this.handlers[type].set(group, value);
	}

	eventHandlers() {
		let _this = this;

		// Change section
		jmin('.dsf-nav-item').on('click', function (e) {
			e.preventDefault();

			if (jmin(this).hasClass('active')) return;

			let container = this.closest('.dsf-container'), section = this.dataset.section;

			jmin(container).find('.dsf-nav-item, .dsf-section').removeClass('active');
			jmin(container).find('.dsf-nav-item[data-section=' + section + '], .dsf-section[data-section=' + section + ']').addClass('active');
		});

		// Change tab
		jmin('.dsf-nav-tab').on('click', function (e) {
			e.preventDefault();

			if (jmin(this).hasClass('active')) return;

			let section = this.closest('.dsf-section'), tab = this.dataset.tab;

			for (let sibling of this.parentNode.children) {
				sibling.classList.remove('active');
			}
			this.classList.add('active');

			jmin(section).find('.dsf-tab').removeClass('active');
			jmin(section).find('.dsf-tab[data-tab=' + tab + ']').addClass('active');
		});


		function get_value(el) {
			return el.value;
		}

		// Save data
		jmin('.dsf-save').on('click', function (e) {
			e.preventDefault();

			let container = this.closest('.dsf-container');

			_this.data = {};

			let success = true;

			jmin(container).find('.dsf-group').each(function (el) {
				let group = el.dataset.group, type = el.dataset.type;

				if (typeof _this.handlers[type] == 'object') {
					let data = _this.get(el);
					if (data !== null) {
						_this.data[group] = data.val;
						_this.map[group] = data.map;
					} else {
						success = false;
					}
				}
			});

			if (success) {
				let args = {
					'request': 'settings-save',
					'option_name': container.dataset.option_name,
					'options': _this.data,
					'map': _this.map,
				};

				DevStudio.request(args, function (response) {
					window.location.reload();
				});
			}
		})

		// Add Storage (custom) handler
		this.storageEventHandlers();
	}

	textHandler() {
		this.addHandler('text', {
			init: function () {
			},
			get: function (group) {
				let input = group.querySelector('input[type=text]'), value = input.value.trim();

				let required = input.getAttribute('required') !== null;
				let disabled = input.getAttribute('disabled') !== null;

				if (required && !disabled && value === '') {
					input.classList.add('dsf-required');
					return null;
				} else {
					input.classList.remove('dsf-required');
					return value;
				}
			},
			set: function (group, value) {
				jmin(group).find('input[type=text]').val(value);
			},
		});
	}


	checkboxHandler() {
		this.addHandler('checkbox', {
			init: function () {
			},
			get: function (group) {
				return jmin(group).find('input[type=checkbox]:checked').elements.length > 0 ? 'yes':'no';
			},
			set: function (group, value) {
				jmin(group).find('input[type=checkbox]').each(function() {
					this.checked = value === 'yes';
				});
			},
		});
	}

	checkboxGroupHandler() {
		this.addHandler('checkbox-groups', {

			init: function () {

				jmin('.dsf-field.dsf-field-checkbox-groups .dsf-cg-parent input[type=checkbox]')
					.on('change', function () {
						let checkbox = this, cgroup = this.closest('.dsf-cgroup');

						jmin(cgroup).find('.dsf-cg-childs input[type=checkbox]').each(function(el) {
							el.checked = checkbox.checked;
						});
					})

				jmin('.dsf-field.dsf-field-checkbox-groups .dsf-cg-childs input[type=checkbox]').on('change', function () {
					let child = this, cgroup = this.closest('.dsf-cgroup');

					jmin(cgroup).find('.dsf-cg-parent input[type=checkbox]').each(function(el) {
						el.checked = jmin(child.closest('.dsf-cg-childs')).find('input[type=checkbox]:checked').elements.length > 0
					});

				});
			},

			get: function (group) {
				let data = [];
				jmin(group).find('.dsf-cg-childs input:checked').each(function (el) {
					data.push(el.value);
				});
				return data;
			},

			set: function (group, value) {
				jmin(group).find('input[type=checkbox]').each(function(el) {
					el.checked = false;
				});

				for(let val of value) {
					jmin.find('.dsf-cg-childs input[type=checkbox][value="' + val + '"]').each(function (el) {
						el.checked = true;
						el.dispatchEvent('change');
					});
				}
			},

		});
	}

	selectHandler() {
		this.addHandler('select', {

			init: function() {
			},

			get: function (group) {
				return jmin(group).find('select').val();
			},

			set: function (group, value) {
				let first_value = jmin(group).find('select option:first').val();

				if ( value!=='' || first_value === '') {
					jmin(group).find('select').val(value);
				} else {
					jmin(group).find('select').elements[0].selectedIndex = 0;
				}
			},
		});
	}

	radioHandler() {
		this.addHandler('radio', {
			init: function () {
			},
			get: function (group) {
				return jmin(group).find('input[type=radio]:checked').elements[0].value;
			},
			set: function (group, value) {
				jmin(group).find('input[type=radio]').each(function() {
					this.checked = value === 'yes';
				});
			},
		});
	}

	storageEventHandlers() {
		let group = document.querySelector('.dsf-group-custom[data-group="storage"]');

		if (group) {
			jmin(group).find('input[type=radio]').on('change', function () {
				let group = this.closest('.dsf-group-custom'), wrap = this.closest('.dsf-wrap');

				let $wraps = jmin(group).find('.dsf-wrap').not(wrap);
				$wraps.removeClass('ds-active');
				$wraps.find('input[type=text]').each((el) => {
					el.setAttribute('disabled','');
					el.classList.remove('dsf-required');
				});

				let $wrap = jmin(wrap).addClass('ds-active');
				$wrap.find('input[type=text]').each((el) => {
					el.removeAttribute('disabled');
				});

			});
		}

		// Test Filesystem
		jmin(group).find('#ds-btn_storage_test_filesystem').on('click', function (e) {
			e.preventDefault();

			let directory = jmin(group).find('input[name="storage_directory"]').val();

			DevStudio.request({request: 'test-filesystem', directory}, function (response) {
				DevStudio.openModal(response.html, 'ds-center');
			});
		});

		// Test Redis Connection
		jmin(group).find('#ds-btn_storage_test_redis').on('click', function (e) {
			e.preventDefault();

			let wrap = this.closest('.dsf-wrap');
			let
				data = {
					request: 'test-redis',
					host: jmin(wrap).find('input[name="storage_redis_host"]').val(),
					port: jmin(wrap).find('input[name="storage_redis_port"]').val(),
					password: jmin(wrap).find('input[name="storage_redis_password"]').val(),
					database: jmin(wrap).find('input[name="storage_redis_database"]').val()
			};
			let directory = jmin(group).find('input[name="storage_directory"]').val();

			DevStudio.request(data, function (response) {
				DevStudio.openModal(response.html, 'ds-center');
			});
		});
	}
}
